import React, {Component} from 'react';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";

let headers = [
    {title: 'Incluir'},
    {title: 'Código'},
    {title: 'Nombre'},
    {title: 'default'},
];

class PayMethodModal extends Component {
    componentDidMount(): void {
        this.closeAction();
    }


    closePayMethod = async () => {

        $('#payMethodsModal').modal('hide');
    }

    closeAction = () => {
        const {cleanData} = this.props;
        $('#payMethodsModal').on('hidden.bs.modal', () => {
            //console.log("Close payMethodsModal");
            cleanData();
        });
    };


    render() {
        const {data, selectpayMethod} = this.props;
        //console.log("data payMethodsModal", data);
        if (data.length === 0) {
            return <div className="modal fade bd-example-modal-lg bgtransparent" role="dialog" id="payMethodsModal"></div>;
        }
        return (
            <div>
                <div className="modal fade bd-example-modal-lg bgtransparent" role="dialog" id="payMethodsModal"
                     aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
          
                        <div className="modal-content">
              
                            <div className="modal-header text-white"
                                 style={{backgroundColor: '#343a40', borderRadius: '0'}}>
                                <h4 className="modal-title" id="modal-basic-title ">Impuesto</h4>
                                <button type="button" className="close" onClick={this.closePayMethod}
                                        aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="table-responsive">
                                                <table className="table response" style={{marginBottom: 0}}>
                                                    <tbody>
                                                    <DataTablesCreate data={data} headers={headers}
                                                                      view={"payMethodsModal"}
                                                                      action={selectpayMethod}/>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white"
                                        onClick={this.closePayMethod}>Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PayMethodModal;